import { useCallback, useEffect, useState } from "react";
import { connectorsStatus, connectorsHealth } from "@/lib/rootConsole";

const card = { background: "#121924", border: "1px solid #22303f", borderRadius: 10, padding: 16, marginBottom: 16 };
const btn = { background: "#30363d", color: "#fff", border: "none", borderRadius: 8, padding: "8px 14px", cursor: "pointer", marginTop: 8 };
const th = { textAlign: "left", color: "#8b98a5", fontSize: 12, padding: "6px 8px", borderBottom: "1px solid #22303f" };
const td = { color: "#d7e0ea", fontSize: 13, padding: "6px 8px", borderBottom: "1px solid #1a2430" };
const COLOR = { CONNECTED: "#7ee787", NOT_CONFIGURED: "#8b98a5", DEGRADED: "#e3b341", OFFLINE: "#ff7b72" };

// Phase C — Registre connecteurs (états normalisés, endpoints non-secrets).
export default function ConnectorsPanel() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { const d = await connectorsStatus(); setRows(d.connectors || []); setErr(null); }
    catch (e) { setErr(e?.response?.data?.detail || "Connectez-vous en Founder."); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const check = async () => { setBusy(true); try { const d = await connectorsHealth(); setRows(d.connectors || []); } catch (e) { setErr(String(e)); } finally { setBusy(false); } };

  return (
    <div style={card} data-testid="root-connectors">
      <h3 style={{ color: "#58a6ff", marginTop: 0 }}>Registre des connecteurs</h3>
      <div style={{ color: "#8b98a5", fontSize: 12, marginBottom: 8 }}>Source : Galaxy Registry. Aucun secret exposé — endpoint public uniquement.</div>
      {err && <div style={{ ...card, borderColor: "#f85149", color: "#ff7b72" }} data-testid="connectors-error">{err}</div>}
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead><tr><th style={th}>Connecteur</th><th style={th}>Capability</th><th style={th}>Endpoint</th><th style={th}>Dépendance</th><th style={th}>Fallback</th><th style={th}>État</th></tr></thead>
        <tbody>
          {rows.map((c) => (
            <tr key={c.name} data-testid={`connector-${c.name}`}>
              <td style={td}>{c.name} <span style={{ color: "#8b98a5" }}>· {c.provider}</span></td>
              <td style={td}>{c.capability}</td>
              <td style={td}>{c.endpoint || "—"}</td>
              <td style={{ ...td, color: c.dependency ? "#ff7b72" : "#7ee787" }}>{c.dependency ? "oui" : "non"}</td>
              <td style={td}>{c.fallback || "—"}</td>
              <td style={{ ...td, color: COLOR[c.state] || "#8b98a5", fontWeight: 700 }}>{c.state}{c.latency_ms != null ? ` · ${c.latency_ms}ms` : ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <button style={btn} onClick={check} disabled={busy} data-testid="connectors-health">{busy ? "Sonde…" : "Health check"}</button>
    </div>
  );
}
